import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import logger from "redux-logger";

import authReducer from "../features/Auth/authSlice";
import createOrderReducer from "../features/CreateOrder/createOrderSlice";
import cancelOrderReducer from "../features/CancelOrder/cancelOrderSlice";
import driversReducer from "../features/Drivers/driversSlice";
import ordersReducer from "../features/Orders/ordersSlice";
import schedulesReducer from "../features/Schedules/scheduleSlice";
import deliveriesReducer from "../features/Deliveries/deliveriesSlice";
import dumpYardsReducer from "../features/DumpYards/dumpYardsSlice";
import pickupsReducer from "../features/Pickups/pickUpsSlice";
import receivedOrdersReducer from "../features/ReceivedOrders/receivedOrdersSlice";
import clientDashboardReducer from "../features/ClientDashboard/clientDashboardSlice";
import punchCardReducer from "../features/PunchCards/punchCardSlice";
import reportsReducer from "../features/Reports/reportsSlice";
import dumpstersReducer from "../features/Dumpsters/dumpstersSlice";
import vehiclesReducer from "../features/Vehicles/vehiclesSlice";
import dvirReducer from "../features/DVIR/dvirSlice";
import driversV2Reducer from "../features/DriversV2/driversV2Slice";
import paymentsReducer from "../features/Payments/paymentsSlice";
import apiKeysReducer from "../features/Settings/apiKeysSlice";
import pricingReducer from "../features/Settings/pricingSlice";
import settingsReducer from "../features/Settings/settingsSlice";
import payrollReducer from "../features/Settings/payrollSlice";
import fleetOptimizationReducer from "../features/FleetOptimization/fleetOptimizationSlice";
import customersReducer from "../features/Customers/customersSlice";
import customerOrdersReducer from "../features/Customers/customerOrdersSlice";
import dumpEventsReducer from "../features/DumpYards/dumpEventsSlice";
import receiptsReducer from "../features/Receipts/receiptsSlice";
import invoiceSuggestionsReducer from "../features/DumpYards/invoiceSuggestionsSlice";
import chatReducer from "../features/Chat/chatSlice";
import closedDaysReducer from "../features/Settings/closedDaysSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    createOrder: createOrderReducer,
    cancelOrder: cancelOrderReducer,
    drivers: driversReducer,
    orders: ordersReducer,
    schedules: schedulesReducer,
    deliveries: deliveriesReducer,
    dumpYards: dumpYardsReducer,
    pickups: pickupsReducer,
    receivedOrders: receivedOrdersReducer,
    clientDashboard: clientDashboardReducer,
    punchCards: punchCardReducer,
    reports: reportsReducer,
    dumpsters: dumpstersReducer,
    vehicles: vehiclesReducer,
    dvir: dvirReducer,
    driversV2: driversV2Reducer,
    payments: paymentsReducer,
    apiKeys: apiKeysReducer,
    pricing: pricingReducer,
    settings: settingsReducer,
    payroll: payrollReducer,
    fleetOptimization: fleetOptimizationReducer,
    customers: customersReducer,
    customerOrders: customerOrdersReducer,
    dumpEvents: dumpEventsReducer,
    receipts: receiptsReducer,
    invoiceSuggestions: invoiceSuggestionsReducer,
    chat: chatReducer,
    closedDays: closedDaysReducer,
  },
  middleware: (defaultMiddleware) =>
    process.env.NODE_ENV === "development"
      ? defaultMiddleware().concat(logger)
      : defaultMiddleware(),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
